/**
 * @file: index.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The 2×2 KPI grid above the lead cards: 全部商机 / 跟进中 / 已预约 wired to the live
 * filter-driven `LeadStats`, plus 本月新增 which counts leads created this calendar
 * month independently of the page filters.
 */

import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { LeadStats } from '@euler/model/lead/types';
import {
  CalendarCheck,
  ListChecks,
  PhoneCall,
  TrendingUp,
} from 'lucide-react-native';
import { memo } from 'react';
import { View } from 'react-native';
import { KpiCard } from './KpiCard';

export const LeadKpiGrid = memo(
  ({
    stats,
    monthlyNewCount,
  }: {
    stats: LeadStats | undefined;
    monthlyNewCount: number | undefined;
  }) => {
    const { rpx } = useResponsiveContext();
    // Until stats load every metric shows the dash; once loaded a status the
    // server omitted (count 0) reads as 0, not a dash.
    const row = {
      flexDirection: 'row',
      gap: rpx(8),
    } as const;
    return (
      <View
        style={{
          marginHorizontal: rpx(16),
          marginBottom: rpx(12),
          gap: rpx(8),
        }}
      >
        <View style={row}>
          <KpiCard
            value={stats?.total}
            label="全部商机"
            icon={ListChecks}
            iconColor="#0066FF"
            iconBg="#EEF5FF"
          />
          <KpiCard
            value={stats ? stats.byStatus.working ?? 0 : undefined}
            label="跟进中"
            icon={PhoneCall}
            iconColor="#0066FF"
            iconBg="#EEF5FF"
          />
        </View>
        <View style={row}>
          <KpiCard
            value={stats ? stats.byStatus.booked ?? 0 : undefined}
            label="已预约"
            icon={CalendarCheck}
            iconColor="#047857"
            iconBg="#ECFDF3"
          />
          <KpiCard
            value={monthlyNewCount}
            label="本月新增"
            icon={TrendingUp}
            iconColor="#C2410C"
            iconBg="#FFF7ED"
          />
        </View>
      </View>
    );
  },
);
